import { createFileRoute } from '@tanstack/react-router';
import { PasswordResetSuccessPage } from '../components/auth/PasswordResetSuccessPage';

export const Route = createFileRoute('/password-reset-success')({
  component: PasswordResetSuccess,
});

function PasswordResetSuccess() {
  return <PasswordResetSuccessPage />;
}
